/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UnpairDeviceModel as DigiworkMaitreDPosDtoEmployeeUnpairDeviceModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Employee/unpair-device-model';

export interface UnPairDevice_1$Params {
      body?: DigiworkMaitreDPosDtoEmployeeUnpairDeviceModel
}

export function unPairDevice_1(http: HttpClient, rootUrl: string, params?: UnPairDevice_1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, unPairDevice_1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

unPairDevice_1.PATH = '/api/mng/Venue/unpairdevice';
